<template>
  <div class="vh-100 overflow-hidden">
    <div class="app flex-row align-items-center h-100">
      <div class="container" style="max-width: 800px">
        <h4>{{ $t("Webportal.External.Login.Introduction") }}</h4>
        <p class="text-muted">
          {{ $t("Webportal.External.Login.Introduction.Description") }}
        </p>

        <b-row class="pt-3">
          <b-col md>
            <b-form-group
              :label="$t('Webportal.FirstName')"
              label-for="firstName"
            >
              <b-form-input
                autofocus
                trim
                id="firstName"
                v-model="externalUser.FirstName"
                @change="v$.externalUser.FirstName.$touch()"
                @keyup.enter="continueClicked"
              />
            </b-form-group>
          </b-col>
          <b-col md>
            <b-form-group
              :label="$t('Webportal.LastName')"
              label-for="lastName"
            >
              <b-form-input
                trim
                id="lastName"
                v-model="externalUser.LastName"
                @change="v$.externalUser.LastName.$touch()"
                @keyup.enter="continueClicked"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group :label="$t('Webportal.EmailAddress')" label-for="email">
          <b-form-input
            id="email"
            v-model="externalUser.Email"
            :state="isEmailValid"
            trim
            @keyup.enter="continueClicked"
          />
        </b-form-group>

        <b-form-group>
          <b-form-checkbox id="remember" v-model="remember">
            {{ $t("Webportal.External.Login.Remember") }}
          </b-form-checkbox>
        </b-form-group>

        <b-form-group>
          <b-button
            variant="primary"
            :disabled="!isFormValid"
            @click="continueClicked"
          >
            {{ $t("Webportal.Continue") }}
          </b-button>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import AuthenticationService from "@/services/AuthenticationService";

import useVuelidate from '@vuelidate/core';
import { required, email, helpers } from '@vuelidate/validators';

export default {
  name: "ExternalLogin",

  setup() {
    return { v$: useVuelidate() };
  },

  validations() {
    return {
      externalUser: {
        FirstName: { required: helpers.withMessage(this.$t('Validation.Required', { FieldName: this.$t('Webportal.FirstName') }), required) },
        LastName: { required: helpers.withMessage(this.$t('Validation.Required', { FieldName: this.$t('Webportal.LastName') }), required) },
        Email: {
          required: helpers.withMessage(this.$t('Validation.Required', { FieldName: this.$t('Webportal.EmailAddress') }), required),
          email: helpers.withMessage(this.$t('Validation.Email', { FieldName: this.$t('Webportal.EmailAddress') }), email)
        }
      }
    };
  },

  data() {
    return {
      externalUser: {},
      remember: true,
    };
  },

  computed: {
    isEmailValid() {
      return !this.v$.externalUser.Email.$error;
    },

    isFormValid() {
      return !this.v$.$error;
    },
  },

  mounted() {
    if (!this.$route.params.redirectTo) this.$router.push({ name: "notfound" });
  },

  methods: {
    continueClicked() {
      if (this.isEmailValid) {
        AuthenticationService.loginExternal(
          this.$route.params.redirectTo,
          this.externalUser,
          this.remember
        )
          .then(() => {
            let redirectTo = this.$route.params.redirectTo;
            // Remove sicc for security reasons
            if (redirectTo.query.sicc) delete redirectTo.query.sicc;
            this.$router.replace({
              path: redirectTo.path,
              query: redirectTo.query,
              replace: true,
            });
          })
          .catch((e) => {
            console.error(e)
            this.$router.push({ name: "error" });
          });
      }
    },
  },
};
</script>
